module.exports = __webpack_public_path__ + "assets/img/home-icon.7355bc48.png";